import api, { apiSetup } from '../api';

apiSetup();

export class PriorizacionesService {
  BASE_URL = '/priorizaciones';

  get() {
    return api.get(this.BASE_URL);
  }
}
